import React, { useEffect, useState } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import "../../css/interviews.css";
import { InterviewType } from "../../interfaces/user";
import { DateFormatter } from "../../functions/commons";
import {
  DATE_FORMAT3,
  DATE_FORMAT5,
  TIME_FORMAT1,
} from "../../constants/stringConstants";
import { Image } from "antd";
import { isNil } from "lodash";

type InterviewItemPropsType = {
  data: InterviewType;
};

function InterviewListingItem(props: InterviewItemPropsType) {
  const { data } = props;
  const { jobApplication, date, startTime } = data;
  const { companyJob } = jobApplication;

  return (
    <div
      className="interview_listing_item"
      style={{ backgroundColor: "white" }}
    >
      <div className="flex_row_center interview_companyName">
        {!isNil(companyJob?.company?.companyLogo) ? (
          <Image
            src={companyJob.company.companyLogo}
            style={{
              width: "27px",
              height: "27px",
              marginRight: "10px",
              borderRadius: "100px",
            }}
          />
        ) : (
          <AccountCircleIcon
            color="disabled"
            style={{ width: "30px", height: "30px", marginRight: "10px" }}
          />
        )}
        <text>{companyJob.company.companyName}</text>
      </div>
      <div
        className="interview_jobTitle"
        // style={{
        //   width: "35%",
        //   alignItems: "flex-start",
        //   display: "flex",
        // }}
      >
        <text>{companyJob.jobTitle}</text>
      </div>
      <div className="interview_schedule_container">
        <div>
          <CalendarMonthOutlinedIcon
            style={{
              height: "22px",
              width: "22px",
              marginRight: "10px",
            }}
          />
          <text>{DateFormatter(date, DATE_FORMAT5)}</text>
        </div>

        <div>
          <QueryBuilderIcon
            style={{
              height: "22px",
              width: "22px",
              marginRight: "10px",
            }}
          />
          <text>{DateFormatter(startTime, TIME_FORMAT1)}</text>
        </div>
      </div>
    </div>
  );
}
export default InterviewListingItem;
